"use strict";
exports.__esModule = true;
exports.formatHTML = void 0;
var basic_chart_component_1 = require("../../../../basic-component/basic-chart.component");
function formatHTML(originalHtml) {
    var html = '<span style="font-family: sans-serif;">' + originalHtml + '</span>';
    // Replace Quill align class with html style align
    html = html.replace(/class="ql-align-center"/g, 'style="text-align: center;"');
    html = html.replace(/class="ql-align-left"/g, 'style="text-align: left;"');
    html = html.replace(/class="ql-align-right"/g, 'style="text-align: right;"');
    html = html.replace(/class="ql-align-justify"/g, 'style="text-align: justify;"');
    var list = [];
    var trimmedList = [];
    html.replace(/<(.*?)>/g, function (a, b) {
        list.push(a);
        trimmedList.push(b);
    });
    trimmedList.forEach(function (l, idx) {
        var lOrig = angular.copy(l);
        // Replace Quill indent class with html style indent
        var indentIdx = l.indexOf('class="ql-indent-');
        if (indentIdx != -1) {
            var indentBy = l[indentIdx + 'class="ql-indent-'.length];
            var searchVal = 'class="ql-indent-' + indentBy + '"';
            var replaceVal = 'style="text-indent: ' + (40 * indentBy) + 'px; "';
            lOrig = lOrig.replace(searchVal, replaceVal);
            html = html.replace(list[idx], '<' + lOrig + '>');
        }
        // Consolidate multiple html styles in a tag into single style
        var count = (l.match(/style="/g) || []).length;
        if (count > 1) {
            var style_1 = 'style="';
            l.replace(/style="(.*?)"/g, function (a, b) {
                lOrig = lOrig.replace(' style="' + b + '"', '');
                style_1 += b + ' ';
            });
            lOrig = '<' + lOrig + ' ' + style_1 + '">';
            html = html.replace(list[idx], lOrig);
        }
    });
    return html;
}
exports.formatHTML = formatHTML;
angular.module('smartorg.r6.acts.smartText').directive('smartText', ['$timeout', '$rootScope', function ($timeout, $rootScope) {
        return {
            restrict: 'E',
            template: require('../../template/smart-text.html'),
            scope: {
                smartorg: '=?',
                menu: '='
            },
            link: function (scope) {
                scope.showSave = false;
                scope.compareToCurrent = false;
                scope.compareToPrev = false;
                function showAlert(type, title, message) {
                    scope.$emit('workbench:alert', {
                        type: type,
                        title: title,
                        message: message
                    });
                }
                function decode(string) {
                    try {
                        return decodeURIComponent(string);
                    }
                    catch (e) {
                        return string;
                    }
                }
                scope.$on('command:TEXT', function (event, args) {
                    scope.showSave = false;
                    scope.actionMenuItem = args.actionMenuItem;
                    if (args.config.data) {
                        scope.nodeId = args.nodeID;
                        scope.nodeName = args.config.data.name;
                        scope.params = args.config.data.params;
                        scope.disabled = args.config.data.nodeAttribute == "r";
                        scope.currentUser = args.username;
                        scope.historyLog = [];
                        if (scope.params) {
                            for (var i = 0; i < args.config.data.smartText.length; i++) {
                                var item = args.config.data.smartText[i];
                                scope.params.forEach(function (box) {
                                    item.data[box.key] = decode(item.data[box.key]);
                                });
                                scope.historyLog.push(item);
                            }
                            var defaultText = {};
                            for (var i = 0; i < scope.params.length; i++) {
                                defaultText[scope.params[i].key] = "";
                            }
                            scope.currentText = args.config.data.smartText && args.config.data.smartText.length ?
                                angular.copy(args.config.data.smartText[args.config.data.smartText.length - 1].data) : defaultText;
                        }
                        else {
                            scope.historyLog.push(decode(args.config.data.smartText));
                            scope.currentText = angular.copy(decode(args.config.data.smartText));
                        }
                        scope.originalText = angular.copy(scope.currentText);
                        scope.saving = false;
                    }
                    scope.menu = menu;
                    setTimeout(function () {
                        scope.$apply();
                    }, 0);
                });
                scope.compareList = function (a1, a2) {
                    if (a1 && a2) {
                        if (a1.length != a2.length) {
                            return false;
                        }
                        a1 = a1.sort();
                        a2 = a2.sort();
                        for (var i = 0; i < a1.length; i++) {
                            if (a1[i] != a2[i]) {
                                return false;
                            }
                        }
                        return true;
                    }
                    return !a1 && !a2;
                };
                scope.compareDict = function (d1, d2) {
                    if (d1 && d2) {
                        var key1 = Object.keys(d1);
                        var key2 = Object.keys(d2);
                        // Compare keys
                        // if keys are not the same, return false
                        if (!scope.compareList(key1, key2)) {
                            return false;
                        }
                        // else
                        // Compare values
                        for (var i = 0; i < key1.length; i++) {
                            if (d1[key1[i]] != d2[key2[i]]) {
                                return false;
                            }
                        }
                        return true;
                    }
                    else {
                        return !d1 && !d2;
                    }
                };
                scope.checkSave = function () {
                    var toComare = {};
                    if (!scope.historyLog || !scope.historyLog.length) {
                        for (var i = 0; i < scope.params.length; i++) {
                            toComare[scope.params[i].key] = "";
                        }
                    }
                    else {
                        toComare = scope.historyLog[scope.historyLog.length - 1].data;
                    }
                    scope.showSave = !scope.compareDict(scope.currentText, toComare);
                    $timeout(function () {
                        $rootScope.smartorgDirty = scope.showSave;
                    }, 0);
                };
                scope.saveSmartText = function (nodeID, text) {
                    if (!text) {
                        text = '&nbsp;';
                    }
                    var textToSave = {};
                    // loop through text encode data
                    for (var i = 0; i < scope.params.length; i++) {
                        textToSave[scope.params[i].key] = encodeURIComponent(text[scope.params[i].key]);
                    }
                    scope.smartorg.saveSmartText(nodeID, btoa(JSON.stringify(textToSave))).then(function () {
                        scope.historyLog.push({
                            'data': angular.copy(scope.currentText),
                            'SavedBy': scope.currentUser,
                            'SavedOn': new Date().toString()
                        });
                        scope.saving = false;
                        scope.originalText = angular.copy(scope.currentText);
                        $timeout(function () {
                            $rootScope.smartorgDirty = scope.showSave;
                        }, 0);
                        scope.$apply();
                    })["catch"](function (err) {
                        showAlert("danger", "Server Error " + err.status, err.message);
                    });
                };
                scope.showHistory = function (direction) {
                    scope.historyIndex += direction;
                };
                scope.showHistoryModal = function (box) {
                    scope.historyTag = box;
                    scope.historyIndex = scope.historyLog.length - 1;
                    $('#textHistoryModal').modal('show');
                };
                scope.reset = function () {
                    scope.currentText = angular.copy(scope.originalText);
                    scope.showSave = false;
                    $timeout(function () {
                        $rootScope.smartorgDirty = scope.showSave;
                    }, 0);
                };
                scope.toDate = function (str) {
                    return new Date(str);
                };
                var menu = [{
                        'name': 'Save',
                        'class': 'btn btn-xs btn-danger',
                        'show': function () {
                            return scope.showSave && !scope.saving;
                        },
                        'callback': function () {
                            scope.showSave = false;
                            scope.saving = true;
                            scope.saveSmartText(scope.nodeId, scope.currentText);
                        }
                    }, {
                        'name': 'Reset',
                        'class': 'btn btn-xs btn-primary',
                        'show': function () {
                            return scope.showSave && !scope.saving;
                        },
                        'callback': function () {
                            scope.reset();
                        }
                    }, {
                        'name': '',
                        'class': 'btn btn-xs btn-danger',
                        'icon': 'fa fa-spinner fa-spin fa-fw',
                        'show': function () {
                            return scope.saving;
                        }
                    }, {
                        'name': 'Export',
                        'items': [{
                                'name': 'Word Document',
                                'callback': function () {
                                    var title = scope.actionMenuItem + '_for_' + scope.nodeName;
                                    var html = '';
                                    var _loop_1 = function (key, value) {
                                        scope.params.forEach(function (box) {
                                            if (key == box.key) {
                                                html += '<b>' + box.Title + '</b><br>';
                                                html += '<p>' + value + '</p><br><br>';
                                            }
                                        });
                                    };
                                    for (var _i = 0, _a = Object.entries(angular.copy(scope.originalText)); _i < _a.length; _i++) {
                                        var _b = _a[_i], key = _b[0], value = _b[1];
                                        _loop_1(key, value);
                                    }
                                    var formattedHtml = formatHTML(angular.copy(html));
                                    (0, basic_chart_component_1.exportHTML)(formattedHtml, title);
                                }
                            }]
                    }];
            }
        };
    }]);
//# sourceMappingURL=smart-text-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/smart-text/app/js/plumbing/smart-text-directive.js